/**
 * Afterpay payment method - uses shared BNPL factory.
 */

import { POPUP_CLOSED_GRACE_MS } from "./bnpl-lifecycle";
import {
  type BnplCheckoutResponse,
  type BnplCustomerInfo,
  type BnplSubmitOptions,
  createBnplPaymentMethod,
} from "./bnpl-shared";

export type AfterpayCustomerInfo = BnplCustomerInfo;

export type AfterpaySubmitOptions = Omit<BnplSubmitOptions, "setupFutureUsage">;

export type AfterpayCheckoutResponse = BnplCheckoutResponse;

const AfterpayPaymentMethod = createBnplPaymentMethod({
  name: "afterpay",
  endpointPath: "afterpay",
  supportsSetupFutureUsage: false,
  popupClosedGraceMs: POPUP_CLOSED_GRACE_MS,
});

export default AfterpayPaymentMethod;
